import InlineSvg from 'svg-inline-react'
import { ToolTip, Button } from '@driftt/tide-core-legacy'

import PlayIconSrc from '!svg-inline?removeTags=true!images/svg/play-sequences.svg'
import EmailIconSrc from '!svg-inline?removeTags=true!images/svg/email-sequences.svg'
import UsersIconSrc from '!svg-inline?removeTags=true!images/svg/users-sequences.svg'
import GreenCheckIconSrc from '!svg-inline?removeTags=true!images/svg/check.svg'
import BrowserIconSrc from '!svg-inline?removeTags=true!images/svg/browser.svg'
import { CHROME_EXTENSION_LINK } from 'constants/ResourcesConstants'

import PlaybookDraftToggle from '../../PlaybookDraftToggle'

import './style.styl'


const OutboundSequenceReview = ({
  isGmailConnected,
  onConnectGmailClick,
  isExtensionInstalled,
  onInstallExtensionClick,
}) => (
  <div>
    <div className="sequence-review-stacked sequence-review-item">
      <div className="sequence-review-header">
        <InlineSvg src={EmailIconSrc}
          element="div"
          className="sequence-icon-svg"
          style={{
            width: 25,
            height: 25,
          }}/>
        <h2> 1. Connect your Gmail account </h2>
        {isGmailConnected &&
          <div className="sequence-review-gmail-connected">
            <InlineSvg src={GreenCheckIconSrc}
              element="div"
              style={{
                width: 15,
                height: 15,
                marginRight: 3,
              }}/>
              Connected
          </div>
        }
        </div>
        {!isGmailConnected &&
        <div className="sequence-review-content">
          <span>This is how we send your email! If the rest of your team hasn’t already, encourage them to do the same. </span>
          <div>
            <button className="drift-button drift-button-secondary" onClick={onConnectGmailClick}>Connect</button>
          </div>
        </div>
      }
    </div>
    <hr/>
    <div className="sequence-review-stacked sequence-review-item">
      <div className="sequence-review-header">
        <InlineSvg src={BrowserIconSrc}
          element="div"
          className="sequence-icon-svg"
          style={{
            width: 25,
            height: 25,
          }}/>
        <h2> 2. Install the Chrome extension </h2>
        {isExtensionInstalled &&
          <div className="sequence-review-gmail-connected">
            <InlineSvg src={GreenCheckIconSrc}
              element="div"
              style={{
                width: 15,
                height: 15,
                marginRight: 3,
              }}/>
              Installed
          </div>
        }
      </div>
      {!isExtensionInstalled &&
      <div className="sequence-review-content">
          <span>The Drift Extension turns your email into a super-powered Sales Machine. Install it to start sending automated email sequences from within Salesforce and use it to track email activity (such as opens and clicks). Read more about it <a href="https://help.drift.com/article/using-the-drift-email-extension/" target="_blank">here</a>. </span>,
          <div>
            <button className="drift-button drift-button-secondary" onClick={onInstallExtensionClick}>Install</button>
          </div>
      </div>}
    </div>
    <hr/>
    <div className="sequence-review-stacked sequence-review-item">
      <div className="sequence-review-header">
        <InlineSvg src={PlayIconSrc}
          element="div"
          className="sequence-icon-svg"
          style={{
            width: 25,
            height: 25,
          }}/>
        <h2> 3. Make this sequence available to send </h2>
      </div>
      <div className="sequence-review-content">
        <span>Turning this on won’t automatically send any emails - it just makes it so you can start enrolling leads to get this sequence. </span>
        <div>
          <PlaybookDraftToggle />
        </div>
      </div>
    </div>
    <hr/>
    <div className="sequence-review-stacked sequence-review-item">
      <div className="sequence-review-header">
        <InlineSvg src={UsersIconSrc}
          element="div"
          className="sequence-icon-svg"
          style={{
            width: 25,
            height: 25,
          }}/>
        <h2> 4. Start sending! </h2>
      </div>
      <div className="sequence-review-content--start-sending">
          <span>You can enroll contacts from Drift, or use our <a target="_blank" href={CHROME_EXTENSION_LINK} rel="noopener noreffer"> Chrome extension </a> to enroll right from Salesforce or your Gmail inbox! </span>
        <div className="sequence-review-grid">
          <div>
            <ToolTip
              component={(!isGmailConnected && <div>You need to connect your Gmail before <br/> you can enroll contacts in sequences</div>) ||
              (<div>Select and enroll contacts right  <br/> from Drift’s contact list</div>)}
              flow="up"
              className="outbound-sequence-tooltip"
              >
              <Button type="tertiary" href="/contacts" target="_self" disabled={!isGmailConnected}>Enroll from Drift</Button>
            </ToolTip>
          </div>
          <div>
            <ToolTip
              component={(!isGmailConnected && <div>You need to connect your Gmail before <br/> you can enroll contacts in sequences</div>) ||
                          (!isExtensionInstalled && <div>You need to install the Chrome extension before <br/> enrolling from Salesforce</div>) ||
                          (<div>Select and enroll contacts right <br/>  from Salesforce</div>)}
              flow="up"
              className="outbound-sequence-tooltip"
              >
              <Button type="tertiary" href="https://login.salesforce.com/" disabled={!isGmailConnected || !isExtensionInstalled}>Enroll from Salesforce</Button>
            </ToolTip>
          </div>
          <div>
            <ToolTip
              component={(!isGmailConnected && <div>You need to connect your Gmail before <br/> you can enroll contacts in sequences</div>) ||
                          (!isExtensionInstalled && <div>You need to install the Chrome <br/> extension before enrolling from Gmail</div>) ||
                          (<div>Enroll prospects by their email address <br/> with the Chrome extension</div>)}
              flow="up"
              className="outbound-sequence-tooltip"
              >
                <Button type="tertiary" href="https://gmail.com" disabled={!isGmailConnected || !isExtensionInstalled}>Enroll from Gmail</Button>
            </ToolTip>
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default OutboundSequenceReview



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Review/OutboundSequence/index.js